import validate from "/data/root-data/TG/lip-sync/master/lip-sync/node_modules/.pnpm/nuxt@3.21.5_@parcel+watcher@2.5.6_@types+node@22.19.19_@vue+compiler-sfc@3.5.34_better-_e3fd2a4e19b437fbd207cf7b4f73ca20/node_modules/nuxt/dist/pages/runtime/validate.js";
import blog_45en_45only_45global from "/data/root-data/TG/lip-sync/master/lip-sync/src/middleware/blog-en-only.global.ts";
import sidebar_45user_45pref_45global from "/data/root-data/TG/lip-sync/master/lip-sync/src/middleware/sidebar-user-pref.global.ts";
import manifest_45route_45rule from "/data/root-data/TG/lip-sync/master/lip-sync/node_modules/.pnpm/nuxt@3.21.5_@parcel+watcher@2.5.6_@types+node@22.19.19_@vue+compiler-sfc@3.5.34_better-_e3fd2a4e19b437fbd207cf7b4f73ca20/node_modules/nuxt/dist/app/middleware/route-rules.js";
export const globalMiddleware = [
  validate,
  blog_45en_45only_45global,
  sidebar_45user_45pref_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}